// src/components/hooks/useModal.js

import { useState, useCallback } from 'react';

/**
 * 모달의 열림/닫힘 상태를 관리하는 커스텀 훅
 * @param {boolean} initialMode 초기 상태 (기본값: false)
 * @returns {object} { isOpen, open, close, toggle }
 */
const useModal = (initialMode = false) => {
    // 모달 상태 관리
    const [isOpen, setIsOpen] = useState(initialMode);

    // 모달 열기 (메모이제이션으로 불필요한 리렌더링 방지)
    const open = useCallback(() => {
        setIsOpen(true);
    }, []);

    // 모달 닫기
    const close = useCallback(() => {
        setIsOpen(false);
    }, []);

    // 모달 토글 (열림<->닫힘 전환)
    const toggle = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);

    return { isOpen, open, close, toggle };
};

export default useModal;